<template>
    <Layout>
      <StripePayment :amount="100" @payment-success="handlePaymentSuccess" />
    </Layout>
  </template>
  
  <script>
  import Layout from '@/components/Layout.vue'
  import StripePayment from '@/components/Stripe.vue'
  
  export default {
    components: {
      Layout,
      StripePayment
    },
    methods: {
      handlePaymentSuccess(paymentData) {
        console.log('支付成功:', paymentData);
        // 处理支付成功逻辑
      }
    }
  }
  </script>